import React, {Component} from 'react'

const ANDROID = 'Android'
const IOS = 'iOS'

export class LinkTo extends Component {
  getMobileOperatingSystem = () => {
    let userAgent = navigator.userAgent || navigator.vendor

    if (/android/i.test(userAgent)) {
      return ANDROID
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return IOS
    }
  }

  detectAndRedirect = () => {
    const appRoute = window.location.href.split('/link-to/')[1] || ''
    const iframe = document.createElement('iframe')
    iframe.style.border = 'none'
    iframe.style.width = '1px'
    iframe.style.height = '1px'
    // if app is installed, it will go to the app
    iframe.src = 'com.nexoutlets.mobile://' + appRoute

    if (this.getMobileOperatingSystem() === ANDROID) {
      document.body.appendChild(iframe)
      // if the app is not installed, redirect to the correct store
      setTimeout(() => window.location.replace('http://play.google.com/store/apps/details?id=com.nexoutlets.mobile'), 250)
    }

    if (this.getMobileOperatingSystem() === IOS) {
      window.location = iframe.src
      // if the app is not installed, redirect to the correct store
      setTimeout(() => window.location.replace('https://itunes.apple.com/us/app/nex-outlets/id763309053?mt=8'), 3000)
    }
  }

  componentDidMount () {
    this.detectAndRedirect()
  }

  render () {
    return <div style={{padding: 20}}>
      <h1>Download NEX Mobile!</h1>
      <p style={{maxWidth: 400}}>
        Start saving now!
        Make sure you don't miss another coupon, promotion, or exclusive offer from the stores at
        Nebraska Crossing Outlets - Nebraska's newest shopping destination.
        Premier brands at outlet prices!
      </p>
      <br />

      <a href='https://play.google.com/store/apps/details?id=com.nexoutlets.mobile'>
        <img src={'https://developer.android.com/images/brand/en_app_rgb_wo_45.png'} alt='GooglePlay Store' style={{height: 44, marginRight: 10}} />
      </a>

      <a href='https://itunes.apple.com/us/app/nex-outlets/id763309053?mt=8'>
        <img src={'//linkmaker.itunes.apple.com/assets/shared/badges/en-us/appstore-lrg.svg'} alt='iOS AppStore' className='img-responsive' style={{height: 44}} />
      </a>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/pages/link-to.js